(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interior-gallery"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.interior-gallery').forEach(function (root) {
    var chips = root.querySelectorAll('[data-filter]');
    var projects = root.querySelectorAll('.interior-project');
    var empty = root.querySelector('[data-gallery-empty]');
    if (!chips.length) { return; }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var wanted = chip.getAttribute('data-filter');
        var shown = 0;

        chips.forEach(function (other) {
          other.setAttribute('aria-selected', String(other === chip));
        });

        projects.forEach(function (project) {
          var match = wanted === 'all' || project.getAttribute('data-category') === wanted;
          project.hidden = !match;
          if (match) { shown += 1; }
        });

        if (empty) { empty.hidden = shown !== 0; }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
